import type { IconProps } from '../../types/global.types';

const AddIcon = ({ size }: IconProps) => {
  return (
    <svg
      width={size || '24'}
      height={size || '24'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.5C9 4.22386 8.77614 4 8.5 4C8.22386 4 8 4.22386 8 4.5V8H4.5C4.22386 8 4 8.22386 4 8.5C4 8.77614 4.22386 9 4.5 9H8V12.5C8 12.7761 8.22386 13 8.5 13C8.77614 13 9 12.7761 9 12.5V9H12.5C12.7761 9 13 8.77614 13 8.5C13 8.22386 12.7761 8 12.5 8H9V4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AddIcon;
